import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { PracticeProfilePage } from '@/pages/PracticeProfile'

export const Route = createFileRoute('/_authenticated/practices_/$practiceId')({
  component: CustomerDetailGuard,
})

function CustomerDetailGuard() {
  return (
    <PermissionRouteGuard resource="customer_profiles" action="read">
      <CustomerDetailRoute />
    </PermissionRouteGuard>
  )
}

function CustomerDetailRoute() {
  const { practiceId } = Route.useParams()
  return <PracticeProfilePage customerId={practiceId} />
}
